export const REACTIONS_SVG_URLS = {
  happy: `https://static-cdn.spot.im/production/reactions/images/happy-x8bb909dfa82f8b9502fc3929f4325350.svg`,
  surprised: `https://static-cdn.spot.im/production/reactions/images/surprised-x8bb909dfa82f8b9502fc3929f4325350.svg`,
  sad: `https://static-cdn.spot.im/production/reactions/images/sad-xx8bb909dfa82f8b9502fc3929f4325350.svg`,
  angry: `https://static-cdn.spot.im/production/reactions/images/angry-x8bb909dfa82f8b9502fc3929f4325350.svg`
};

export const CUSTOM_REACTION_PREFIX = 'https://spotim-prd-static-assets.s3.amazonaws.com/custom-content';

export const DEFAULT_TITLE = 'How Do You Feel About This Article?';